<table role="grid" [attr.aria-label]="monthLabel()" [attr.aria-multiselectable]="range() ? true : null">
  <thead>
    <tr>
      @for (weekday of locale.weekdays; track $index) {
        <th scope="col" [attr.aria-label]="locale.weekdayLabels[$index]">
          {{ weekday }}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (week of weeks(); track $index) {
      <tr [class.empty-week]="isEmptyWeek(week)">
        @for (day of week; track $index) {
          <td [attr.aria-selected]="day ? (isEndpoint(day) || isInRange(day)) : null">
            @if (day) {
              <button
                #dayButton
                type="button"
                [attr.data-date]="day.toString()"
                [attr.aria-label]="dayLabel(day)"
                [attr.aria-describedby]="dayContent() ? contentId + day.toString() : null"
                [class.has-content]="!!dayContent()"
                [class.today]="!!today()?.equals(day)"
                [attr.aria-current]="today()?.equals(day) ? 'date' : null"
                [attr.aria-disabled]="isDisabled(day)"
                [class.disabled]="isDisabled(day)"
                [tabIndex]="activeDate().equals(day) ? 0 : -1"
                [class.in-range]="isInRange(day)"
                [class.selected]="isEndpoint(day)"
                [class.range-start]="!!range()?.start.equals(day)"
                [class.range-end]="!!range()?.end.equals(day)"
                (pointerenter)="datePreview.emit(day)"
                (focus)="datePreview.emit(day)"
                (click)="select(day)"
                (keydown)="onKeydown($event, day)">
                {{ day.dayOfMonth() }}
                @if (dayContent()) {
                  <span class="day-content" [id]="contentId + day.toString()">
                    <ng-container [ngTemplateOutlet]="dayContent()"
                      [ngTemplateOutletContext]="{$implicit: day, selected: isEndpoint(day), disabled: isDisabled(day)}" />
                  </span>
                }
              </button>
            } @else if (fixedSixWeeks()) {
              <span class="empty-day" aria-hidden="true"></span>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
